import React from 'react';
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';

const ArrowSortUp = (props) => <ArrowUpwardIcon {...props} />;

export default ArrowSortUp;
